// Resolve a product/logo image reference to a fully qualified URL.
// Handles three shapes we store in the DB:
//   1. Absolute http(s) URL      → used as-is
//   2. Absolute path (/api/...)  → prefix with backend origin only
//   3. Bare storage path (edsteel/...) → prefix with `${BACKEND}/api/files/`
export function resolveImageUrl(value) {
  if (!value) return '';
  const backend = process.env.REACT_APP_BACKEND_URL || '';
  if (value.startsWith('http://') || value.startsWith('https://') || value.startsWith('data:')) {
    return value;
  }
  if (value.startsWith('/')) {
    return `${backend}${value}`;
  }
  return `${backend}/api/files/${value}`;
}
